(ns practitest.frontend.components2.tooltip
  (:require [practitest.frontend.components.overlay2 :as overlay2]
            [reagent.core :as reagent]))

(def direction-class
  {"top"    "mux-tooltip-top"
   "bottom" "mux-tooltip-bottom"
   "left"   "mux-tooltip-start"
   "right"  "mux-tooltip-end"})

(def alignment-class
  {"start" "mux-tooltip-arrow-start"
   "end"   "mux-tooltip-arrow-end"})

(defn- placement-classes [placement]
  (let [[direction alignment] (.split placement "-")]
    [(direction-class direction)
     (alignment-class alignment)]))

(defn ^{:component? true} tooltip
  "Hover tooltip built on top of floating-ui-overlay
   Shows a styled mux-tooltip on mouse hover over the trigger element.

   All floating-ui-overlay options are supported — see overlay2/floating-ui-overlay for details.

   Defaults: placement \"top\", strategy \"fixed\", offset 8.
   Arrow position is derived from placement (e.g. \"top-start\" → arrow at start).

   Placements (see https://floating-ui.com/docs/computePosition#placement):
     Placement     | Tooltip position          | Arrow alignment
     ------------- | ------------------------- | ---------------
     top           | above, centered           | center
     top-start     | above, left-aligned       | left
     top-end       | above, right-aligned      | right
     bottom        | below, centered           | center
     bottom-start  | below, left-aligned       | left
     bottom-end    | below, right-aligned      | right
     left          | left side, centered       | center
     left-start    | left side, top-aligned    | top
     left-end      | left side, bottom-aligned | bottom
     right         | right side, centered      | center
     right-start   | right side, top-aligned   | top
     right-end     | right side, bottom-aligned| bottom

   opts         - floating-ui-overlay options map
   child-fn     - (fn [hover-props] hiccup) — must merge hover-props onto trigger element
   tooltip-body - tooltip content (string or hiccup)

   Examples:
     [hover-tooltip
      {:placement \"top-start\" :offset 12}
      (fn [props] [:span.label props \"Hover over me\"])
      \"Full description shown in tooltip\"]"
  ([child-fn tooltip-body]
   [tooltip {} child-fn tooltip-body])
  ([opts child-fn tooltip-body]
   (let [show?            (reagent/atom false)
         actual-placement (reagent/atom nil)
         show-fn          #(reset! show? true)
         hide-fn          #(reset! show? false)
         defaults         {:strategy            "fixed"
                           :offset              8
                           :flip                true
                           :shift?              true
                           :on-request-close    hide-fn
                           :on-placement-change #(reset! actual-placement %)}]
     (fn [{:keys [placement] :or {placement "top"} :as opts}
          child-fn tooltip-body]
       (let [overlay-opts (merge defaults {:placement placement :show? @show?} opts)
             classes      (placement-classes (or @actual-placement placement))]
         [overlay2/floating-ui-overlay overlay-opts
          (child-fn {:on-mouse-enter show-fn
                     :on-mouse-leave hide-fn})
          [:div.mux-tooltip.mux-tooltip-static {:class classes}
           [:div.tooltip-arrow]
           [:div.mux-tooltip-inner tooltip-body]]])))))
